import { render } from "./flightCard.vue?vue&type=template&id=ec564912&scoped=true"
import script from "./flightCard.vue?vue&type=script&lang=js"
export * from "./flightCard.vue?vue&type=script&lang=js"

import "./flightCard.vue?vue&type=style&index=0&id=ec564912&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec564912"]])

export default __exports__